// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,

  // Quiz common translations
  quiz: {
    password: {
      title: `Password Protected`,
      description: `Please enter the password to continue.`,
      label: `Password`,
      submit: `Unlock`,
      invalid: `Invalid password. Please try again.`,
    },
    progress: {
      completed: `{{percentage}}% completed`,
      questionsAnswered: `{{current}} of {{total}} questions answered`,
      label: "Progress",
    },
    navigation: {
      previous: `Previous`,
      next: `Next`,
      finish: `Finish`,
    },
    likert: {
      stronglyDisagree: `Strongly Disagree`,
      disagree: `Disagree`,
      neutral: `Neutral`,
      agree: `Agree`,
      stronglyAgree: `Strongly Agree`,
    },
    pdf: {
      download: `Download PDF`,
      downloading: `Downloading...`,
    },
    errors: {
      verificationFailed: `Password verification failed. Please try again.`,
      submissionFailed: `Failed to submit results. Your results are still displayed.`,
      loadQuestionsFailed: `Failed to load questions. Please try again.`,
    },

    // Big Five specific translations
    big5: {
      password: {
        title: `Big Five Personality Test`,
        description: `This test is password protected. Please enter the workshop password to begin.`,
      },
      intro: {
        title: `Big Five Personality Test`,
        subtitle: `BFI-2 - Big Five Inventory 2`,
        description: `This test measures five fundamental personality dimensions: Extraversion, Agreeableness, Conscientiousness, Neuroticism, and Openness to Experience. The results will help you understand yourself better.`,
        instructions: {
          title: `Instructions`,
          item1: `Read each statement carefully.`,
          item2: `Rate how well each statement describes you.`,
          item3: `There are no right or wrong answers.`,
          item4: `Answer spontaneously and honestly.`,
        },
        start: `Start Test`,
        nameLabel: `Your Name`,
        namePlaceholder: `Please enter your name`,
        genderLabel: `Gender`,
        genderMale: `Male`,
        genderFemale: `Female`,
        sourceText: `The Big Five personality test is a scientifically widely recognized methodology for personality analysis. More information can be found at:`,
        sourceCitation: `Soto, C. J., & John, O. P. (2017). The next Big Five Inventory (BFI-2):
        Developing and assessing a hierarchical model with 15 facets to enhance
        bandwidth, fidelity, and predictive power. Journal of Personality and
        Social Psychology, 113, 117-143.`,
      },
      submitting: `Processing results...`,
      generatingReport: `Your personal report is being created`,
      loadingQuestions: `Loading questions...`,
      results: {
        title: `Your Results`,
        titlePersonalized: `Results for {{name}}`,
        subtitle: `Here are your Big Five personality results`,
        summary: `Summary`,
        summaryText: `Your highest score is in {{highestTrait}} ({{highestPercentage}} percentile), while {{lowestTrait}} ({{lowestPercentage}} percentile) is your lowest.`,
        retake: `Retake Test`,
        disclaimer: `These results are for self-reflection only and do not constitute a professional psychological assessment.`,
        detailedResults: `Detailed Results`,
        percentileLabel: `{{percentile}}th percentile`,
        percentileExplanation: `Your score for {{trait}} is at the {{percentile}}th percentile. Out of 100 people, {{lower}} would score higher than you and {{higher}} would score lower.`,
        aiInterpretation: `AI Interpretation`,
        aiDisclaimer: `This interpretation was generated by AI and serves as a guide. It does not replace professional advice.`,
        aiUnavailable: `AI interpretation is currently unavailable.`,
        strengths: `Strengths`,
        developmentAreas: `Development Areas`,
        errorTitle: `Error Loading Results`,
        errorDescription: `The results could not be loaded. Please try again.`,
      },
      traits: {
        extraversion: {
          name: `Extraversion`,
          description: `Describes the tendency to be sociable, assertive, and energetic. High scores indicate an outward-focused, active personality.`,
        },
        agreeableness: {
          name: `Agreeableness`,
          description: `Measures the tendency to be cooperative, trusting, and helpful. High scores show a friendly and considerate nature.`,
        },
        conscientiousness: {
          name: `Conscientiousness`,
          description: `Refers to self-discipline, reliability, and goal-orientation. High scores indicate organized and responsible behavior.`,
        },
        neuroticism: {
          name: `Neuroticism`,
          description: `Describes the tendency to experience negative emotions like anxiety, sadness, and irritability. Low scores indicate emotional stability.`,
        },
        openness: {
          name: `Openness`,
          description: `Measures creativity, intellectual curiosity, and openness to new experiences. High scores show imagination and appreciation for art and ideas.`,
        },
      },
      levels: {
        veryLow: `Very Low`,
        low: `Low`,
        average: `Average`,
        high: `High`,
        veryHigh: `Very High`,
      },
      questions: {
        q1: `I am outgoing, sociable.`,
        q2: `I am compassionate, warm-hearted.`,
        q3: `I tend to be disorganized.`,
        q4: `I stay calm even in stressful situations.`,
        q5: `I am not particularly interested in art.`,
        q6: `I am assertive, energetic.`,
        q7: `I treat others with respect.`,
        q8: `I am laid-back, tend to be lazy.`,
        q9: `I remain optimistic even after setbacks.`,
        q10: `I have many different interests.`,
        q11: `I rarely get overly enthusiastic.`,
        q12: `I tend to criticize others.`,
        q13: `I am steady, consistent.`,
        q14: `I can be moody, have fluctuating moods.`,
        q15: `I am inventive, come up with clever solutions.`,
        q16: `I am rather quiet.`,
        q17: `I have little sympathy for others.`,
        q18: `I am systematic, keep my things in order.`,
        q19: `I get tense easily.`,
        q20: `I can get excited about art, music and literature.`,
        q21: `I tend to take charge.`,
        q22: `I often have arguments with others.`,
        q23: `I tend to procrastinate.`,
        q24: `I am self-assured, satisfied with myself.`,
        q25: `I avoid philosophical discussions.`,
        q26: `I am less active and adventurous than others.`,
        q27: `I am forgiving, easily forgive others.`,
        q28: `I am sometimes quite careless.`,
        q29: `I am even-tempered, not easily upset.`,
        q30: `I am not particularly imaginative.`,
        q31: `I am rather shy.`,
        q32: `I am helpful and selfless.`,
        q33: `I like things clean and tidy.`,
        q34: `I often worry.`,
        q35: `I appreciate art and beauty.`,
        q36: `I find it hard to influence others.`,
        q37: `I am sometimes rude and abrupt.`,
        q38: `I am efficient, get things done quickly.`,
        q39: `I often feel dejected, joyless.`,
        q40: `I enjoy thinking deeply about complex things and understanding them.`,
        q41: `I am full of energy and drive.`,
        q42: `I am suspicious of others.`,
        q43: `I am reliable, others can count on me.`,
        q44: `I have my emotions under control, rarely get angry.`,
        q45: `I am not particularly imaginative.`,
        q46: `I am talkative.`,
        q47: `I am rather indifferent to others.`,
        q48: `I am the chaotic type, rarely clean up.`,
        q49: `I rarely get nervous and insecure.`,
        q50: `I find poems and plays boring.`,
        q51: `In a group, I prefer to let others decide.`,
        q52: `I am polite and courteous.`,
        q53: `I stick with a task until it is done.`,
        q54: `I am often depressed, down.`,
        q55: `I have little interest in abstract considerations.`,
        q56: `I am enthusiastic and can easily inspire others.`,
        q57: `I easily trust others, believe in the good in people.`,
        q58: `Sometimes I behave irresponsibly, recklessly.`,
        q59: `I get irritated or annoyed quickly.`,
        q60: `I am original, develop new ideas.`,
      },
    },
  },
};

export default en;
